import { __assign, __rest } from 'tslib';
import MuiFormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';
import React from 'react';
import { u as useFormControlContext } from '../../form-control-context-fc570f22.js';

var FormHelperTextRoot = styled(MuiFormHelperText)(function (_a) {
    var theme = _a.theme, control = _a.control, fontSize = _a.fontSize;
    var _b = theme.componentsConfig, radio = _b.radio, checkbox = _b.checkbox, svgIcon = _b.svgIcon, switchMediumComponent = _b.switch.medium;
    return __assign(__assign(__assign(__assign({}, (fontSize === 'medium' && theme.typography.body1)), (control === 'checkbox' && {
        paddingLeft: svgIcon.size.medium + checkbox.padding * 2,
        marginLeft: 0,
    })), (control === 'radio' && {
        paddingLeft: svgIcon.size.medium + radio.padding * 2,
        marginLeft: 0,
    })), (control === 'switch' && {
        paddingLeft: switchMediumComponent.offsetSize.width,
        marginLeft: 0,
    }));
});
var FormHelperText = React.forwardRef(function FormHelperText(_a, ref) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? 'small' : _b, propsControl = _a.control, restProps = __rest(_a, ["fontSize", "control"]);
    var formControlContext = useFormControlContext();
    var control = propsControl || formControlContext.control;
    return (React.createElement(FormHelperTextRoot, __assign({}, __assign(__assign({}, restProps), { control: control, fontSize: fontSize }), { ref: ref })));
});

export { FormHelperText as default };
